"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSettingsSection = void 0;
const react_1 = __importDefault(require("react"));
const forms_1 = require("../../forms");
const __1 = require("..");
const ProductSettingsSection_styles_1 = require("./ProductSettingsSection.styles");
const ProductSettingsSection = (props) => {
    const { title, items, children, hideItems } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null, title && (react_1.default.createElement(ProductSettingsSection_styles_1.ProductSettingsSectionWrapper, null,
        react_1.default.createElement(ProductSettingsSection_styles_1.SectionHeaderWrapper, null,
            react_1.default.createElement(__1.SectionHeader, Object.assign({}, props))),
        !hideItems && (react_1.default.createElement(ProductSettingsSection_styles_1.InputFieldsSection, null, children ? children : items === null || items === void 0 ? void 0 : items.map((item, index) => react_1.default.createElement(forms_1.InputField, Object.assign({ key: index }, item)))))))));
};
exports.ProductSettingsSection = ProductSettingsSection;
//# sourceMappingURL=ProductSettingsSection.js.map